import { render } from "./PointsRedeemManagement.html?vue&type=template&id=5fed6c65&scoped=true"
import script from "./PointsRedeemManagement.js?vue&type=script&lang=js"
export * from "./PointsRedeemManagement.js?vue&type=script&lang=js"

import "./PointsRedeemManagement.css?vue&type=style&index=0&id=5fed6c65&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/Shiptech MyPlusRewards/mpr-web-admin-portal/src/MPR.MyPlusRewardsAdminPortal.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fed6c65"]])

export default __exports__